export interface Plonky2Proof {
  proof: string;
}

export interface Plonky2Vk {
  vk: string;
}

export interface Plonky2Pubs {
  pubs: string;
}
